import { render } from "./HomeBenefits.vue?vue&type=template&id=ba397ac0"
import script from "./HomeBenefits.vue?vue&type=script&lang=js"
export * from "./HomeBenefits.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__